import { render, staticRenderFns } from "./loginAnimate.vue?vue&type=template&id=0cf98d56&scoped=true&"
var script = {}
import style0 from "./loginAnimate.vue?vue&type=style&index=0&id=0cf98d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf98d56",
  null
  
)

component.options.__file = "loginAnimate.vue"
export default component.exports